/* eslint-disable object-property-newline */
/* eslint-disable camelcase */
import { spLig, spCh, spCh2, spAmp, spPunc, quote, handleSpCh } from './spchars';
import { bdepth_btag_balign_bclass_balign2_bdot, nl, blockTag, blockNl } from './tags/block';
import { ilb_itag_ila_iclass, inlineTag } from './tags/inline';
import { blist, listTag } from './tags/list';
import { hclose_htag_hattrs, httpTag } from './tags/http';
import { fntag_fnnum, parseifn } from './tags/footnote';
import { rxJoin, Parms } from './tools';
import { State } from './state';

const rx = rxBuild();

export function getDom(text, init) {
  if (typeof text !== 'string') return;
  const state = new State(init);
  text.replace(rx, rxCb.bind(null, state));
  state.writeText(text);
  state.end();
  return state;
}

function rxBuild() {
  const or = '|';
  const rx2 = [
    spLig, or, spCh, or, spCh2, or, spAmp, or, spPunc,
    or, hclose_htag_hattrs,
    or, quote,
    or, bdepth_btag_balign_bclass_balign2_bdot,
    or, blist,
    or, nl,
    or, fntag_fnnum,
    or, ilb_itag_ila_iclass,
  ];
  const source = rxJoin(rx2);
  return new RegExp(source, 'igm');
}

/* eslint-disable padded-blocks */
function rxCb(state, match,
  /* eslint-disable no-shadow */
  spLig, spCh, spCh2, spAmp, spPunc,
  hclose, htag, hattrs,
  quote,
  bdepth, btag, balign, bclass, balign2, bdot, blist, nl,
  fntag, fnnum, ilb, itag, ila, iclass,
  /* eslint-enable no-shadow */
  i, str) {

  const parms = new Parms({
    match,
    spLig, spCh, spCh2, spAmp, spPunc,
    hclose, htag, hattrs,
    quote,
    bdepth: bdepth?.length,
    btag, balign: balign + balign2, bclass, bdot, blist, nl,
    fntag, fnnum, ilb, itag, ila, iclass,
    i, str,
  });
  state.parms = parms;

  if (i > state.i0) state.writeText(str, i);
  state.i0 = i + match.length;

  if (btag) {
    blockTag(state, parms);
  } else if (blist) {
    listTag(state, parms);
  } else if (nl) {
    blockNl(state, parms);
  } else if (state.findOpen('b', 'script') || state.findOpen('b', 'style')) {
    // script and style tags: no inline/spchar/etc replacements!
    state.writeText(str, i);
  } else if (itag) {
    inlineTag(state, parms);
  } else if (fntag) {
    parseifn(fnnum, state, parms);
  } else if (htag) {
    httpTag(state, parms);
  } else if (spCh || spCh2 || spAmp || spPunc || spLig || quote) {
    handleSpCh(state, parms);
  }

  delete state.parms;
}
/* eslint-enable padded-blocks */
